import { useEffect, useContext, useState } from 'react';
import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-fluent-component/wizard';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { PERMISSION_STATUS } from '@bingads-webui-campaign-react/linkedin-utils';
import { connectToLinkedInCompanyPage, getCompanyPagePermissionStatus } from '@bingads-webui-campaign-react/linkedin-data';

import { COMPANY_PAGE_LINKING_ACTIONS } from '../reducer';

export const useSaveCompanyPage = (state, dispatch, onContinue, logger) => {
  const { send } = useWizardService();
  const { scope } = useContext(ScopeContext);
  const { cid, aid } = scope.values;
  const [isProcessing, setIsProcessing] = useState(false);

  const { isSavingCompanyPage, authorizationData, selectedCompanyPage } = state;

  useEffect(() => {
    if (isSavingCompanyPage && !isProcessing) {
      setIsProcessing(true);
      connectToLinkedInCompanyPage(cid, aid, {
        authorizationData,
        companyPageID: selectedCompanyPage.Id,
        LinkedInTnCAccepted: true,
      })
        .then(() => getCompanyPagePermissionStatus(cid, aid))
        .then((res) => {
          logger.trace(`Company page ${selectedCompanyPage.Id} saved: ${JSON.stringify(res)}`);
          send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, {
            connectedCompanyPage: selectedCompanyPage,
          });
          dispatch({
            type: COMPANY_PAGE_LINKING_ACTIONS.COMPANY_PAGE_SAVED,
            connectedCompanyPage: selectedCompanyPage,
            permissionStatus: res.value,
          });
          if (res.value === PERMISSION_STATUS.APPROVED) {
            // Go to ads step
            onContinue();
          } else if (res.value === PERMISSION_STATUS.NOT_FOUND) {
            throw new Error('permission_status_not_found');
          }
        })
        .catch((err) => {
          logger.trace(`Failed to save company page: ${JSON.stringify(err)}`);
          dispatch({ type: COMPANY_PAGE_LINKING_ACTIONS.COMPANY_PAGE_SAVE_FAILED, saveCompanyPageError: err });
        })
        .finally(() => {
          setIsProcessing(false);
        });
    }
  }, [aid, authorizationData, cid, dispatch, isProcessing, isSavingCompanyPage, logger, onContinue, selectedCompanyPage, send]);
};
